<svg
  [attr.width]="width"
  [attr.height]="height"
  preserveAspectRatio="xMidYMid meet"
  [attr.viewBox]="'0 0 ' + width + ' ' + height"
  class="tabIcon"
  [ngClass]="colorClass"
  [style.color]="color"
>
  <use [attr.xlink:href]="'assets/svg/Icons.svg#' + iconName"></use>
</svg>
